module.exports = __webpack_public_path__ + "img/Yellow.d622be1a.svg";